import { Box } from "@mui/material";
import { ReceiptPb } from "../protobufs/receipt_payload";
import { A, ReceiptContainer, ReceiptContent, ReceiptDivider, ReceiptLine, ReceiptOrganizationHeaderContainer, ReceiptTotal } from "./ReceiptLayout.styles";
import QRCode from "react-qr-code";
import { calculateVatRates, formatCurrency, formatDateTime, paymentMethodNames } from "../logic/ReceiptCalculationHelpers";
import { Logo } from "./Logo";

interface Props {
    receipt: ReceiptPb;
}

export default function ReceiptLayout(props: Props) {
    const vatRates = calculateVatRates(props.receipt);

    return <ReceiptContainer>
        <ReceiptOrganizationHeaderContainer>
            <h1>{props.receipt.organizationName}</h1>
            <p>
                {props.receipt.organizationStreet} {props.receipt.organizationStreetNumber} <br />
                {props.receipt.organizationPostalCode} {props.receipt.organizationTown}
            </p>
        </ReceiptOrganizationHeaderContainer>

        <ReceiptLine>
            Datum: {formatDateTime(props.receipt.documentStartTimeUnix)}
        </ReceiptLine>
        <ReceiptLine>
            Vorgangsbeginn: {formatDateTime(props.receipt.timeFirstOrderUnix)}
        </ReceiptLine>
        <ReceiptLine>
            Belegnummer: {props.receipt.receiptNumber}
        </ReceiptLine>
        <ReceiptLine>
            Bedienung: {props.receipt.actorName}
        </ReceiptLine>

        <ReceiptDivider />

        <Box sx={{
            mt: 3,
            mb: 3,
            maxWidth: "100%",
            display: "grid",
            gridTemplateColumns: "30px 50px 1fr 75px 75px",
            gridTemplateRows: "auto",
        }}>
            <Box></Box>
            <Box>Stk.</Box>
            <Box>Artikel</Box>
            <Box sx={{ textAlign: 'end' }} >EPreis</Box>
            <Box sx={{ textAlign: 'end' }} >GPreis</Box>

            {
                props.receipt.positions.map((p) => <>
                    <Box>{vatRates[p.vat].letter}</Box>
                    <Box>{p.amount}</Box>
                    <Box>{p.title}</Box>
                    <Box sx={{ textAlign: 'end' }} >{formatCurrency(p.basePriceCents)}</Box>
                    <Box sx={{ textAlign: 'end' }} >{formatCurrency(p.grossValueCents)}</Box>
                </>)
            }
        </Box>

        <ReceiptDivider />
        <ReceiptTotal>Gesamt: {formatCurrency(props.receipt.totalGrossValueCents)}</ReceiptTotal>
        <ReceiptDivider />

        <Box sx={{
            mt: 3,
            mb: 3,
            maxWidth: "100%",
            display: "grid",
            gridTemplateColumns: "30px 1fr 75px 75px 75px",
            gridTemplateRows: "auto",
        }}>
            <Box></Box>
            <Box>MwSt.</Box>
            <Box sx={{ textAlign: 'end' }} >Netto</Box>
            <Box sx={{ textAlign: 'end' }} >Steuer</Box>
            <Box sx={{ textAlign: 'end' }} >Brutto</Box>

            {
                Object.values(vatRates).map((v) => <>
                    <Box>{v.letter}</Box>
                    <Box>{v.vat}</Box>
                    <Box sx={{ textAlign: 'end' }} >{formatCurrency(v.netCents)}</Box>
                    <Box sx={{ textAlign: 'end' }} >{formatCurrency(v.taxCents)}</Box>
                    <Box sx={{ textAlign: 'end' }} >{formatCurrency(v.grossCents)}</Box>
                </>)
            }
        </Box>

        <ReceiptLine>
            Zahlungsart: {paymentMethodNames[props.receipt.paymentMethod]}
        </ReceiptLine>

        <ReceiptLine>
            Bezahlt: {formatCurrency(props.receipt.payedGrossValueCents)} EUR
        </ReceiptLine>

        {
            props.receipt.organizationTaxNumber.trim().length > 0 &&
            <ReceiptLine>
                Steuernummer: {props.receipt.organizationTaxNumber}
            </ReceiptLine>
        }
        {
            props.receipt.organizationTaxIdentificationNumber.trim().length > 0 &&
            <ReceiptLine>
                Steuer-IdNr.: {props.receipt.organizationTaxIdentificationNumber}
            </ReceiptLine>
        }

        <ReceiptContent>
            <QRCode
                style={{ width: '66%' }}
                value={props.receipt.tseQrCodeContent} />
        </ReceiptContent>
        <ReceiptContent>
            <A href="https://www.order-assist.de" target="_blank">
                <Logo />
                www.order-assist.de
            </A>
        </ReceiptContent>
    </ReceiptContainer>
}